// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I55T","clinicsSelect":"styles_clinicsSelect__3pXCj"};